/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {CREATE_NOTIFICATION, REMOVE_NOTIFICATION, UPDATE_NOTIFICATION} from '../types';

type InitialState = {
	notifications: Array<Notification>;
}

type Notification = {
	name: string;
	isOpen: boolean;
	className: string;
	variant: string;
	actionLabel: string;
	text: string;
	closeOnAction: boolean;
	closable: boolean;
	onActionCallback: Function;
	onCloseCallback: Function;
}

const initialState: {
	notifications: Array<Notification>;
} = {
	notifications: [],
};

export default (state: InitialState = initialState, action) => {
	let notifications;
	switch (action.type) {
		case CREATE_NOTIFICATION:
			if (action.payload) {
				const notificationToCreate = action.payload.new;
				notifications = state.notifications.filter(item => item.name !== notificationToCreate.name);
				return {
					...state,
					notifications: [...notifications, notificationToCreate],
				};
			}
			return state;
		case REMOVE_NOTIFICATION:
			if (action.payload) {
				notifications = state.notifications.filter(item => item.name !== action.payload.name);
				return {
					...state,
					notifications: [...notifications],
				};
			}
			return state;
		case UPDATE_NOTIFICATION:
			if (action.payload) {
				let notificationToUpdate = state.notifications.find(notification => notification.name === action.payload.name);
				if (notificationToUpdate === undefined) {
					notificationToUpdate = action.payload.new;
				}
				else {
					notificationToUpdate = Object.assign(notificationToUpdate, action.payload.new);
				}
				notifications = state.notifications.filter(item => item.name !== notificationToUpdate.name);
				return {
					...state,
					notifications: [...notifications, notificationToUpdate],
				};
			}
			return state;
		default:
			return state;
	}
};
